import { render, staticRenderFns } from "./TwelveLaboursLogo.vue?vue&type=template&id=c95ee532&scoped=true&"
import script from "./TwelveLaboursLogo.vue?vue&type=script&lang=js&"
export * from "./TwelveLaboursLogo.vue?vue&type=script&lang=js&"
import style0 from "./TwelveLaboursLogo.vue?vue&type=style&index=0&id=c95ee532&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c95ee532",
  null
  
)

export default component.exports